export class DateRanges {
    constructor(dateRanges) {
        this.dateRanges = dateRanges;
    }
    canPreorderIn(date) {
        return this.dateRanges.some((dateRange) => dateRange.includes(date));
    }
}
